<template>
  <div class="main player">
    <div class="nav">
      <div class="left" @click="routerback()">
        <!-- <div @click="tocancel" class="icon_back"></div> -->
        <div class="icon_back"></div>
      </div>
      {{ detailsNovel.name }}
      <div class="share" @click="onshare()">
        <div></div>
      </div>
    </div>
    <div class="content">
      <div class="song_disc">
        <div class="song_name">{{ musicName }}</div>
        <div class="song_img_border">
          <!-- <div class="song_img" >
                        <img :src="detailsNovel.img" alt />
          </div>-->
          <div
            class="song_img"
            v-if="!status"
            v-bind:style="{ animation: 'rotate_0 35s linear infinite' }"
          >
            <img :src="detailsNovel.img" alt />
          </div>
          <div class="song_img" v-if="status">
            <img :src="detailsNovel.img" alt />
          </div>
        </div>
      </div>
      <div class="song_bottom">
        <ProgressBar
          :allTime="duration"
          :time="playTime"
          :width="progressWidth"
          @time="changeTime"
        ></ProgressBar>
        <div class="wrapper">
          <div class="audio_model" @click="changeModel()">
            <img src="../assets/images/mode_1.png" alt />
          </div>
          <div class="audio_up" @click="musicUp()">
            <img src="../assets/images/play_up.png" alt />
          </div>
          <div class="audio_paly" @click="toggle()">
            <img v-if="status == false" src="../assets/images/pause.png" alt />
            <img
              v-if="status == true"
              src="../assets/images/tab_play.png"
              alt
            />
          </div>
          <div class="audio_down" @click="musicNext()">
            <img src="../assets/images/play_next.png" alt />
          </div>
          <!-- <div class="audio_aa">
            <img src="../assets/images/play_next.png" alt />
          </div> -->
          <div class="down_img">
            <div
              @click="downLoadEvt($route.query.nid)"
              v-if="verNum >= 229"
            >
              <img src="../assets/images/down.png" alt="" />
              <!-- <p>下载</p> -->
            </div>
          </div>
        </div>
      </div>
      <audio
        :src="audioSources"
        @canplay="getDuration"
        @timeupdate="setTime"
        ref="audio"
        @ended="end"
        autoplay
      ></audio>
      <div class="directory">
        <div class="title">目录</div>
        <div class="choose_list">
          <van-list v-model="loading" :finished="finished" @load="faechPage">
            <van-cell
              v-for="(item, index) in ChapterNovel"
              :key="index"
              class="list_item"
            >
              <!-- <div class="list_item" v-for="(item , index) in VideoList" :key="index" @click="lookNovel(item)"> -->
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
                @click="lookNovel(item)"
              >
                <!-- <div class="resd_order" v-if="historyKey && !musicId">
                                <span v-for="(k , index) in historyKey" v-if=" k.chapter_id == item.id" class="demo2"></span>
                                <span v-else>{{item.numbers}}</span>
                </div>-->
                <div class="resd_order">
                  <span
                    v-if="musicId == item.id && status == false"
                    class="demo2"
                  ></span>
                  <span v-else class="demo1"></span>
                  <!-- <span v-else>{{item.numbers}}</span> -->
                </div>
                <div class="read_info">
                  <p>{{ item.name }}</p>
                  <p>
                    <i>
                      <img src="../assets/images/sc_time.png" alt />
                    </i>
                    {{ formatSeconds(item.duration) }}
                  </p>
                </div>
                <!-- <div
                  class="jz_down"
                  @click="downLoadEvt(item.nid, item.id, $event)"
                  v-if="verNum >= 229"
                >
                  <img src="../assets/images/down.png" alt="" />
                </div> -->
                <!-- <div class="free" v-if="item.is_free == 1 ">免费</div>
                <div class="toll" v-if="item.is_free == 2 ">收费</div>-->
              </div>
            </van-cell>
          </van-list>
        </div>
      </div>
      <div v-if="!loading && finished" class="No_more">我也是有底线的</div>
    </div>
  </div>
</template>
  
<script>
import "../css/player.scss";
import "../css/fiction.scss";
import ProgressBar from "../components/Module/bar";
//    import AudioPlayer from '../components/Module/audioPlayer'
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { useLocal } from "../plugin/tools";
export default {
  components: {
    ProgressBar,
    //   AudioPlayer
  },
  // props:['showstate'] ,
  name: "player",
  data() {
    return {
      playTime: "00:00",
      // allTime: 0,
      progressWidth: 0,
      // status: false,
      detailsNovel: {},
      ChapterNovel: [], //所有文章列表
      ChapterNovel1: {},
      audioSources: "",
      audioObj: null, // audio 对象
      currentId: "", // 当前文章id
      currentNewsId: "", // 当前章节id
      // currentNewsId1: "", //当前文章id
      currentNewsContent: {}, //  当前文章内容
      currentTime: null, // 当前时间进度
      minutes: 0, // 当前分
      seconds: 0, // 当前秒
      duration: 0,
      musicUrl: "",
      listParams: {
        page: 0,
        pageSize: 10,
        nid: 0,
      },
      loading: false,
      finished: false,
      url: "",
      text: "",
      scTime: null,
      // timeName: null,
      novId: "",
      playStatus: "",
      Timeduration: "",
      isSetTime: false, // 是否需要根据url设置当前时间
      // iconFlag : false
    };
  },
  computed: {
    ...mapState("userIndex", [
      "UserData",
      "musicId",
      "showa1",
      "musicName",
      "songListId",
      "detailId",
      "status",
      "Token",
      "novelSection",
      "showa1",
      "historyKey",
      "musicListid",
      "iconFlag",
      "appId",
      "verNum",
    ]),
  },
  watch: {
    $route(to, from) {
      if (to) {
        this.finished = true;
        this.listParams.page = 1;
        this.listParams.pageSize = 10;
        // 默认清空
        this.ChapterNovel = [];
        this.getAllList();
      }
    },

    // showa1() {
    //   if (!this.showa1) {
    //     var mo = function (e) {
    //       passvie: false;
    //     };
    //     document.body.style.overflow = "";
    //     document.removeEventListener("touchmove", mo, false);
    //   }
    //   if (this.showa1) {
    //     var mo = function (e) {
    //       passvie: false;
    //     };
    //     document.body.style.overflow = "hidden";
    //     document.addEventListener("touchmove", mo, false);
    //   }
    // },
    // musicId(newVal, oldVal) {
    //   if (newVal) {
    //     // this.setIconFlag(false)
    //     this.setHistoryKey(newVal);
    //     //  以下为created需要执行的代码
    //     if (!useLocal("remian")) {
    //       useLocal("remian", 2);
    //     }

    //     let delist = this.$route.query.nid || this.songListId;
    //     //当前文章id
    //     this.currentNewsId = this.musicId;
    //     this.fetchNovelDetail({ nid: delist }).then((res) => {
    //       this.detailsNovel = res.data;
    //       this.setDetailId(this.detailsNovel);
    //       // console.log(this.detailsNovel)
    //       this.novId = res.data.id;
    //       let query = this.novId || this.songListId;
    //       this.fetchChapter({ nid: query }).then((res) => {
    //         this.ChapterNovel = res.data.novelChapter;
    //         // console.log(this.ChapterNovel)
    //       });
    //     });
    //     if (this.Token || useLocal("remian") > 1) {
    //       this.fetchPlayUrl({ ncid: this.musicId }).then((res) => {
    //         if (res.code == 500) {
    //           this.setStatus(true);
    //           this.$dialog
    //             .confirm({
    //               message:"您今日的免费收听次数已用完，购买会员套餐可无限畅听奥！",
    //             })
    //             .then(() => {
    //               if (window.android) {
    //                 window.android.pay();
    //               }
    //               if (window.webkit && window.webkit.messageHandlers) {
    //                 window.webkit.messageHandlers.pay.postMessage({});
    //               }
    //             });
    //         } else {
    //           this.setStatus(false);
    //           this.currentNewsContent = res.data;
    //           this.audioSources = res.data.url;
    //           this.musicUrl = res.data.id;
    //           // console.log(this.musicUrl)
    //           useLocal("remian", parseInt(useLocal("remian")) - 1);
    //         }
    //       });
    //     } else {
    //       this.setStatus(true);
    //       this.$dialog
    //         .confirm({
    //           message: "您已用完游客收听次数，请登录畅听",
    //         })
    //         .then(() => {
    //           this.setMusicId("");
    //           this.setShowa1(false);
    //           // this.$router.push({
    //           //     path: "/login" ,
    //           //     query:{
    //           //       platform : this.$route.query.platform
    //           //     }
    //           // });
    //           if (window.android) {
    //             window.android.thirdpartyLogin();
    //           }
    //           if (window.webkit && window.webkit.messageHandlers) {
    //             window.webkit.messageHandlers.thirdpartyLogin.postMessage({});
    //           }
    //         });
    //       this.audioSources = "";
    //     }

    //     this.fecthShare().then((res) => {
    //       this.url = res.data.url;
    //       this.text = res.data.text;
    //     });
    //     this.fetchUserInfo();
    //   }
    // },
  },

  created() {
    // 是否有当前播放进度的参数
    if (this.$route.query.current_time) {
      this.isSetTime = true;
    }
    if (!useLocal("remian")) {
      useLocal("remian", 2);
    }
    let query = this.$route.query;
    // 当前文章id
    this.currentId = this.$route.query.nid;
    // 当前章节id
    this.currentNewsId = this.$route.query.ncid;
    this.setNovelSection(this.currentId);
    this.setMusicId(this.currentNewsId);
    // this.fetchChapter(query).then((res) => {
    //   this.ChapterNovel = res.data.novelChapter;
    //   console.log(this.ChapterNovel);
    // });
    if (this.Token || useLocal("remian") > 1) {
      // console.log(122)
      this.fetchPlayUrl(query).then((res) => {
        if (res.code == 500) {
          this.setStatus(true);
          this.$dialog
            .confirm({
              message: "请登录且开通VIP，VIP会员全部免费畅听！",
            })
            .then(() => {
              // setTimeout(()=>{
              this.sensors.track(
                "VIP_pop",
                {
                  app_id: `${this.appId}`,
                },
                () => {
                  console.log("success");
                }
              );
              if (window && window.android) {
                window.android.pay();
              }
              if (window && window.webkit && window.webkit.messageHandlers) {
                window.webkit.messageHandlers.pay.postMessage({});
              }
              // },1000)
            }).catch(() => {});
        } else {
          this.setStatus(false);
          this.currentNewsContent = res.data;
          this.audioSources = res.data.url.split(",");
          this.musicUrl = res.data.id;
          useLocal("remian", parseInt(useLocal("remian")) - 1);
          // console.log(useLocal("remian"));
        }
      });
    } else {
      // this.status = false;
      this.setMusicId("");
      this.$dialog
        .confirm({
          message: "您已用完游客收听次数，请登录畅听",
        })
        .then(() => {
          if (window && window.android) {
            window.android.thirdpartyLogin();
          }
          if (window && window.webkit && window.webkit.messageHandlers) {
            window.webkit.messageHandlers.thirdpartyLogin.postMessage({});
          }
        }).catch(() => {});
    }

    this.fetchNovelDetail(query).then((res) => {
      this.detailsNovel = res.data;
    });
    this.fecthShare().then((res) => {
      this.url = res.data.url;
      this.text = res.data.text;
    });
    this.fetchUserInfo();
  },
  mounted() {
    if (this.verNum >= 229) {
      let _this = this;
      // 原生方法 播放
      window.playRun = function () {
        _this.toPlay();
        _this.setStatus(false);
      };
      // 原生方法 暂停
      window.playPause = function () {
        _this.toPause();
        _this.setStatus(true);
      };
      // 获取当前播放状态
      window.isPlaying = function(){
        return !_this.status;
      }
    }
    // this.audioTimeUpdate();
    this.$refs.audio.addEventListener("play", this.playTimeSC);
    this.playStatus = this.$refs.audio.paused;
    if (this.playStatus) {
      this.setStatus(false);
    } else {
      this.setStatus(true);
    }

    setTimeout(() => {
      this.sensors.track(
        "YS_Content_Page",
        {
          refer_page: `${this.$route.query.acname}`,
          work_id: this.detailsNovel.id,
          total_chapter_num: this.ChapterNovel1.numbers_sum,
          author_id: this.detailsNovel.anchor_id,
          // played_id_list:`${this.currentNewsId}`,
          // played_times : `${parseInt(this.duration)}`
        },
        () => {
          console.log("success");
        }
      );
      // this.this.Timeduration
    }, 2000);
  },
  beforeDestroy() {
    this.beforeDestroy();
  },
  methods: {
    ...mapActions("userIndex", [
      "fecthShare",
      "fetchNovelDetail",
      "fetchChapter",
      "fetchPlayUrl",
      // "fetchPlaytime",
      "fecthShare",
      "fetchUserInfo",
      // "fetchPlaytime",
      "fetchHistoryList",
      "fetchPause",
      "fetchAddCollectAudio",
      "fetchUpdateCollectAudio",
    ]),
    ...mapMutations("userIndex", [
      "setUserData",
      "setMusicId",
      "setMusicName",
      "setSongListId",
      "setDetailId",
      "setStatus",
      "setToken",
      "setNovelSection",
      "setShowa1",
      "setHistoryKey",
      "setMusicListid",
      "setIconFlag",
      "setappId",
      "setverNum",
    ]),
    tocancel: function () {
      this.$emit("tocancel");
    },
    routerback() {
      this.setMusicName("");
      this.$router.back(-1);
    },
    getDuration() {
      this.duration = this.$refs.audio.duration;
    },
    // audioTimeUpdate() {
    //   this.$refs.audio.addEventListener("timeupdate", this.setTime);
    // },
    setTime(e) {
      this.audioObj = this.$refs.audio;
      if(this.audioObj){
      // this.currentTime = e.target.currentTime;
      // 如果需要调整当前进度
        if (this.isSetTime) {
          this.audioObj.currentTime = this.$route.query.current_time;
          this.isSetTime = false;
        }

        // if(!this.currentTime){
          this.currentTime = this.audioObj.currentTime;
        // }

        this.minutes = Math.floor(this.currentTime / 60);
        this.seconds = Math.floor(this.currentTime - this.minutes * 60);
        // 进行格式转换，当分钟小于10的时候，在前面加0
        if (this.minutes < 10) {
          this.minutes = "0" + this.minutes;
        }
        // 秒数的格式设置
        if (this.seconds < 10) {
          this.seconds = "0" + this.seconds;
        }
        // 进行时间值拼接，展示到页面
        this.playTime = this.minutes + ":" + this.seconds;
        // 进度条的长度计算
        this.setProgress((this.currentTime / this.duration) * 100);
      }
    },
    time_to(time) {
      var s = "";
      var hour = time.split(":")[0];
      var min = time.split(":")[1];
      var sec = time.split(":")[2];
      s = Number(hour * 3600) + Number(min * 60) + Number(sec);
      return s;
    },
    changeTime(time) {
      const audio = this.$refs.audio;
      const current = (time * audio.duration) / 100;
      audio.currentTime = current;
    },
    changeModel() {
      let query = this.$route.query;
      let index = 0;
      index = Math.floor(Math.random() * this.ChapterNovel.length);
      let nextObj = this.ChapterNovel[index];
      // this.setMusicName(nextObj.name)
      // if (nextObj.is_free == 1) {
      // 得到下一篇的id后  请求 url
      if (this.Token || useLocal("remian") > 1) {
        // this.setStatus(false);
        this.fetchPlayUrl({ ncid: nextObj.id }).then((res) => {
          this.setMusicId(nextObj.id);
          this.setMusicName(nextObj.name);
          this.currentNewsContent = res.data;
          this.audioSources = res.data.url;
          useLocal("remian", parseInt(useLocal("remian")) - 1);
        });
      } else {
        // this.setStatus(true);
        this.$dialog
          .confirm({
            message: "您已用完游客收听次数，请登录畅听",
          })
          .then(() => {
            this.setMusicId("");
            this.setShowa1(false);
            if (window && window.android) {
              window.android.thirdpartyLogin();
            }
            if (window && window.webkit && window.webkit.messageHandlers) {
              window.webkit.messageHandlers.thirdpartyLogin.postMessage({});
            }
            // this.$router.push({
            //     path: "/login" ,
            //     query:{
            //         platform : this.$route.query.platform
            //     }
            // });
          }).catch(() => {});
      }
      // }
      // if (nextObj.is_free == 2 && this.UserData == null) {
      //   // this.setStatus(true);
      //   this.$dialog
      //     .confirm({
      //       message: "请登录且开通VIP，VIP会员全部免费畅听！",
      //     })
      //     .then(() => {
      //       // this.$router.push({
      //       //     path: "/member"
      //       // });
      //       if (window && window.android) {
      //         window.android.thirdpartyLogin();
      //       }
      //       if (window && window.webkit && window.webkit.messageHandlers) {
      //         window.webkit.messageHandlers.thirdpartyLogin.postMessage({});
      //       }
      //     });
      //   return;
      // }
      // if (nextObj.is_free == 2 && this.UserData.payment_status == 1) {
      //   // this.setStatus(true);
      //   this.$dialog
      //     .confirm({
      //       message: "请登录且开通VIP，VIP会员全部免费畅听！",
      //     })
      //     .then(() => {
      //       if (window && window.android) {
      //         window.android.pay();
      //       }
      //       if (window && window.webkit && window.webkit.messageHandlers) {
      //         window.webkit.messageHandlers.pay.postMessage({});
      //       }
      //       // this.$router.push({
      //       //     path: "/member"
      //       // });
      //     });
      //   return;
      // }
      // if (nextObj.is_free == 2 && this.UserData.payment_status == 2) {
      //   // this.setStatus(false);
      //   // 得到下一篇的id后  请求 url
      //   this.fetchPlayUrl({ ncid: nextObj.id }).then((res) => {
      //     // this.currentNewsId = nextObj.id;
      //     this.setMusicId(nextObj.id);
      //     this.setMusicName(nextObj.name);
      //     this.setNovelSection(nextObj.nid);
      //     this.currentNewsContent = res.data;
      //     //   this.audioSources = res.token.url.split(',')
      //     this.audioSources = res.data.url;
      //   });
      // }
    },
    //播放暂停
    toggle() {
      if (this.$refs.audio.paused) {
        this.toPlay();
        this.setStatus(false);
        console.log(this.Token);
        // console.log(useLocal("remian"))
        if (!this.Token) {
          this.toPause();
          this.setStatus(true);
          this.$dialog
            .confirm({
              message: "请登录且开通VIP，VIP会员全部免费畅听！",
            })
            .then(() => {
              if (window && window.android) {
                window.android.thirdpartyLogin();
              }
              if (window && window.webkit && window.webkit.messageHandlers) {
                window.webkit.messageHandlers.thirdpartyLogin.postMessage({});
              }
            }).catch(() => {});
          // alert("请登录且开通VIP，VIP会员全部免费畅听！");
          // useLocal("remian", parseInt(useLocal("remian")) - 1);
        } else {
          this.fetchPause().then((res) => {
            if (res.data.num < 0) {
              this.toPause();
              this.setStatus(true);
              this.$dialog
                .confirm({
                  message:
                    "您今日的免费收听次数已用完，购买会员套餐可无限畅听奥！",
                })
                .then(() => {
                  this.sensors.track(
                    "VIP_pop",
                    {
                      app_id: `${this.appId}`,
                    },
                    () => {
                      console.log("success");
                    }
                  );
                  if (window && window.android) {
                    window.android.pay();
                  }
                  if (
                    window &&
                    window.webkit &&
                    window.webkit.messageHandlers
                  ) {
                    window.webkit.messageHandlers.pay.postMessage({});
                  }
                }).catch(() => {});
              // alert("您今日的免费收听次数已用完，购买会员套餐可无限畅听奥！");
            }
          });
        }
      } else {
        this.toPause();
        this.setStatus(true);
        console.log(this.status);
      }
    },
    //播放
    toPlay() {
      if(this.audioSources !== ""){
        this.$refs.audio.play();
      }
      // this.playTimeSC()
    },
    //暂停
    toPause() {
      this.$refs.audio.pause();
      this.beforeDestroy();
    },
    end() {
      this.musicNext();
    },
    //清除播放器
    beforeDestroy() {
      clearInterval(window.timeName);
      window.timeName = null;
    },
    //下一首
    musicNext() {
      let index = this.ChapterNovel.findIndex(
        (content) => content.id == this.currentNewsId
      ); //当前文章下标
      if (index === this.ChapterNovel.length - 1) {
        // this.setStatus(true);
        this.$refs.audio.pause();
        this.setStatus(true);
        this.$dialog({
          message: "已经是最后一章，请重新收听。",
        });
        return;
      }
      if (index == -1) {
        index = 0;
      } else {
        index++;
      }
      let nextObj = this.ChapterNovel[index]; //下一篇对象
      // let a = [this.currentNewsId]
      // a.push(nextObj)
      // console.log(a)
      // if (nextObj.is_free == 1) {
      if (this.Token || useLocal("remian") > 1) {
        // this.setStatus(false);
        // 得到下一篇的id后  请求 url
        this.fetchPlayUrl({ ncid: nextObj.id }).then((res) => {
          if (res.code == 500) {
            this.setStatus(true);
            this.$dialog
              .confirm({
                message: "请登录且开通VIP，VIP会员全部免费畅听！",
              })
              .then(() => {
                this.sensors.track(
                  "VIP_pop",
                  {
                    app_id: `${this.appId}`,
                  },
                  () => {
                    console.log("success");
                  }
                );
                if (window && window.android) {
                  window.android.pay();
                }
                if (window && window.webkit && window.webkit.messageHandlers) {
                  window.webkit.messageHandlers.pay.postMessage({});
                }
              }).catch(() => {});
          } else {
            this.currentNewsId = nextObj.id;
            this.setMusicId(nextObj.id);
            this.setMusicName(nextObj.name);
            this.setNovelSection(nextObj.nid);
            this.currentNewsContent = res.data;
            //   this.audioSources = res.token.url.split(',')
            this.audioSources = res.data.url;
            this.Timeduration = res.data.duration;
            useLocal("remian", parseInt(useLocal("remian")) - 1);
          }
        });
      } else {
        // this.setStatus(true);
        this.$dialog
          .confirm({
            message: "您已用完游客收听次数，请登录畅听",
          })
          .then(() => {
            this.setMusicId("");
            this.setShowa1(false);
            // this.$router.push({
            //     path: "/login" ,
            //     query:{
            //         platform : this.$route.query.platform
            //     }
            // });
            if (window && window.android) {
              window.android.thirdpartyLogin();
            }
            if (window && window.webkit && window.webkit.messageHandlers) {
              window.webkit.messageHandlers.thirdpartyLogin.postMessage({});
            }
          }).catch(() => {});
      }
      // }
      // if (nextObj.is_free == 2 && this.UserData == null) {
      //   // this.setStatus(true);
      //   this.$dialog
      //     .confirm({
      //       message: "请登录且开通VIP，VIP会员全部免费畅听！",
      //     })
      //     .then(() => {
      //       // this.$router.push({
      //       //     path: "/member"
      //       // });
      //       if (window && window.android) {
      //         window.android.thirdpartyLogin();
      //       }
      //       if (window && window.webkit && window.webkit.messageHandlers) {
      //         window.webkit.messageHandlers.thirdpartyLogin.postMessage({});
      //       }
      //     });
      //   return;
      // }
      // if (nextObj.is_free == 2 && this.UserData.payment_status == 1) {
      //   // this.setStatus(true);
      //   this.$dialog
      //     .confirm({
      //       message: "请登录且开通VIP，VIP会员全部免费畅听！",
      //     })
      //     .then(() => {
      //       // this.$router.push({
      //       //     path: "/member"
      //       // });
      //       if (window && window.android) {
      //         window.android.pay();
      //       }
      //       if (window && window.webkit && window.webkit.messageHandlers) {
      //         window.webkit.messageHandlers.pay.postMessage({});
      //       }
      //     });
      //   return;
      // }
      // if (nextObj.is_free == 2 && this.UserData.payment_status == 2) {
      // this.setStatus(false);
      // 得到下一篇的id后  请求 url
      // this.fetchPlayUrl({ ncid: nextObj.id }).then((res) => {
      //   this.setMusicId(nextObj.id);
      //   this.setMusicName(nextObj.name);
      //   this.setNovelSection(nextObj.nid);
      //   this.currentNewsContent = res.data;
      //   //   this.audioSources = res.token.url.split(',')
      //   this.audioSources = res.data.url;
      //   this.Timeduration = res.data.duration
      // });
      setTimeout(() => {
        this.sensors.track(
          "YS_Content_Page",
          {
            refer_page: `${this.$route.query.acname}`,
            work_id: this.detailsNovel.id,
            total_chapter_num: this.ChapterNovel1.numbers_sum,
            author_id: this.detailsNovel.anchor_id,
            // played_id_list:`${this.currentNewsId}`,
            // played_times : `${parseInt(this.duration)}`
          },
          () => {
            console.log("success");
          }
        );
        // console.log(this.Timeduration)
      }, 2000);
      // }
    },
    //上一首
    musicUp() {
      let index = this.ChapterNovel.findIndex(
        (content) => content.id == this.currentNewsId
      ); //当前文章下标
      if (index == 0) {
        return;
      } else {
        index--;
      }
      let nextObj = this.ChapterNovel[index];
      // this.setMusicName(nextObj.name)
      // if (nextObj.is_free == 1) {
      if (this.Token || useLocal("remian") > 1) {
        this.setStatus(false);
        // 得到下一篇的id后  请求 url
        this.fetchPlayUrl({ ncid: nextObj.id }).then((res) => {
          if (res.code == 500) {
            this.setStatus(true);
            this.$dialog
              .confirm({
                message: "请登录且开通VIP，VIP会员全部免费畅听！",
              })
              .then(() => {
                this.sensors.track(
                  "VIP_pop",
                  {
                    app_id: `${this.appId}`,
                  },
                  () => {
                    console.log("success");
                  }
                );
                if (window && window.android) {
                  window.android.pay();
                }
                if (window && window.webkit && window.webkit.messageHandlers) {
                  window.webkit.messageHandlers.pay.postMessage({});
                }
              }).catch(() => {});
          } else {
            this.currentNewsId = nextObj.id;
            this.setMusicId(nextObj.id);
            this.setMusicName(nextObj.name);
            this.setNovelSection(nextObj.nid);
            this.currentNewsContent = res.data;
            //   this.audioSources = res.token.url.split(',')
            this.audioSources = res.data.url;
            this.Timeduration = res.data.duration;
            useLocal("remian", parseInt(useLocal("remian")) - 1);
            // console.log(useLocal("remian"));
          }
        });
      } else {
        // this.setStatus(true);
        this.$dialog
          .confirm({
            message: "您已用完游客收听次数，请登录畅听",
          })
          .then(() => {
            this.setMusicId("");
            this.setShowa1(false);
            // this.$router.push({
            //     path: "/login" ,
            //     query:{
            //         platform : this.$route.query.platform
            //     }
            // });
            if (window && window.android) {
              window.android.thirdpartyLogin();
            }
            if (window && window.webkit && window.webkit.messageHandlers) {
              window.webkit.messageHandlers.thirdpartyLogin.postMessage({});
            }
          }).catch(() => {});
      }
      // }
      // if (nextObj.is_free == 2 && this.UserData == null) {
      //   // this.setStatus(true);
      //   this.$dialog
      //     .confirm({
      //       message: "请登录且开通VIP，VIP会员全部免费畅听！",
      //     })
      //     .then(() => {
      //       // this.$router.push({
      //       //     path: "/member"
      //       // });
      //       if (window && window.android) {
      //         window.android.thirdpartyLogin();
      //       }
      //       if (window && window.webkit && window.webkit.messageHandlers) {
      //         window.webkit.messageHandlers.thirdpartyLogin.postMessage({});
      //       }
      //     });
      //   return;
      // }
      // if (nextObj.is_free == 2 && this.UserData.payment_status == 1) {
      //   // this.setStatus(true);
      //   this.$dialog
      //     .confirm({
      //       message: "请登录且开通VIP，VIP会员全部免费畅听！",
      //     })
      //     .then(() => {
      //       // this.$router.push({
      //       //     path: "/member"
      //       // });
      //       if (window && window.android) {
      //         window.android.pay();
      //       }
      //       if (window && window.webkit && window.webkit.messageHandlers) {
      //         window.webkit.messageHandlers.pay.postMessage({});
      //       }
      //     });
      //   return;
      // }
      // if (nextObj.is_free == 2 && this.UserData.payment_status == 2) {
      //   // this.setStatus(false);
      //   // 得到下一篇的id后  请求 url
      //   this.fetchPlayUrl({ ncid: nextObj.id }).then((res) => {
      //     this.currentNewsId = nextObj.id;
      //     this.setMusicId(nextObj.id);
      //     this.setMusicName(nextObj.name);
      //     this.setNovelSection(nextObj.nid);
      //     this.currentNewsContent = res.data;
      //     //   this.audioSources = res.token.url.split(',')
      //     this.audioSources = res.data.url;
      //   });
      // }
      setTimeout(() => {
        this.sensors.track(
          "YS_Content_Page",
          {
            refer_page: `${this.$route.query.acname}`,
            work_id: this.detailsNovel.id,
            total_chapter_num: this.ChapterNovel1.numbers_sum,
            author_id: this.detailsNovel.anchor_id,
            // played_id_list:`${this.currentNewsId}`,
            // played_times : `${parseInt(this.duration)}`
          },
          () => {
            console.log("success");
          }
        );
        // this.this.Timeduration
      }, 2000);
    },
    setProgress(val) {
      if (val < 0 || val > 100) {
        return;
      }
      this.progressWidth = val;
    },
    // 初始化数据
    getAllList() {
      this.loading = true;
      this.listParams.nid = this.$route.query.nid;
      this.fetchChapter(this.listParams).then((res) => {
        this.loading = false;
        if (res.data == "" || res.data.novelChapter == 0) {
          this.finished = true;
          return false;
        }
        this.finished = false;
        this.ChapterNovel = res.data.novelChapter;
        this.ChapterNovel1 = res.data;
      });
    },
    faechPage() {
      this.listParams.page++;
      this.loading = true;
      this.listParams.nid = this.$route.query.nid;
      this.fetchChapter(this.listParams).then((res) => {
        this.loading = false;
        if (res.data == "" || res.data.novelChapter == 0) {
          this.finished = true;
          return false;
        }
        this.ChapterNovel = this.ChapterNovel.concat(res.data.novelChapter);
        // this.ChapterNovel = res.data.novelChapter;
        this.ChapterNovel1 = res.data;
      });
    },
    lookNovel(item) {
      // console.log("item----", item);
      // console.log("useLocal---", useLocal("remian"));

      // if (item.is_free == 1) {
      // 得到下一篇的id后  请求 url
      if (this.Token || useLocal("remian") > 1) {
        // console.log('测试')
        this.setStatus(false);
        this.fetchPlayUrl({ ncid: item.id }).then((res) => {
          if (res.code == 500) {
            this.setStatus(true);
            this.$dialog
              .confirm({
                message: "请登录且开通VIP，VIP会员全部免费畅听！",
              })
              .then(() => {
                this.sensors.track(
                  "VIP_pop",
                  {
                    app_id: `${this.appId}`,
                  },
                  () => {
                    console.log("success");
                  }
                );
                if (window && window.android) {
                  window.android.pay();
                }
                if (window && window.webkit && window.webkit.messageHandlers) {
                  window.webkit.messageHandlers.pay.postMessage({});
                }
              }).catch(() => {});
          } else {
            this.currentNewsId = item.id;
            this.setMusicId(item.id);
            this.setMusicName(item.name);
            this.setNovelSection(item.nid);
            this.currentNewsContent = res.data;
            //   this.audioSources = res.token.url.split(',')
            this.audioSources = res.data.url;
            this.Timeduration = res.data.duration;
            useLocal("remian", parseInt(useLocal("remian")) - 1);
            console.log(useLocal("remian"));
          }
        });
      } else {
        this.setStatus(true);
        this.$dialog
          .confirm({
            message: "您已用完游客收听次数，请登录畅听",
          })
          .then(() => {
            this.setMusicId("");
            this.setShowa1(false);
            // this.$router.push({
            //     path: "/login" ,
            //     query:{
            //         platform : this.$route.query.platform
            //     }
            // });
            if (window && window.android) {
              window.android.thirdpartyLogin();
            }
            if (window && window.webkit && window.webkit.messageHandlers) {
              window.webkit.messageHandlers.thirdpartyLogin.postMessage({});
            }
          }).catch(() => {});
      }
      // }
      // if (item.is_free == 2 && this.UserData == null) {
      //   this.$dialog
      //     .confirm({
      //       message: "请登录且开通VIP，VIP会员全部免费畅听！",
      //     })
      //     .then(() => {
      //       // this.$router.push({
      //       //     path:'/member',
      //       // })
      //       if (window && window.android) {
      //         window.android.thirdpartyLogin();
      //       }
      //       if (window && window.webkit && window.webkit.messageHandlers) {
      //         window.webkit.messageHandlers.thirdpartyLogin.postMessage({});
      //       }
      //     });
      //   return;
      // }

      // if (item.is_free == 2 && this.UserData.payment_status == 1) {
      //   this.$dialog
      //     .confirm({
      //       message: "请登录且开通VIP，VIP会员全部免费畅听！",
      //     })
      //     .then(() => {
      //       // this.$router.push({
      //       //     path:'/member',
      //       // })
      //       if (window && window.android) {
      //         window.android.pay();
      //       }
      //       if (window && window.webkit && window.webkit.messageHandlers) {
      //         window.webkit.messageHandlers.pay.postMessage({});
      //       }
      //     });
      //   return;
      // }

      // if (item.is_free == 2 && this.UserData.payment_status == 2) {
      //   // this.setStatus(false);
      //   // 得到下一篇的id后  请求 url
      //   this.fetchPlayUrl({ ncid: item.id }).then((res) => {
      //     // this.currentNewsId = item.id;
      //     this.setMusicId(item.id);
      //     this.setMusicName(item.name);
      //     this.setNovelSection(item.nid);
      //     this.currentNewsContent = res.data;
      //     //   this.audioSources = res.token.url.split(',')
      //     this.audioSources = res.data.url;
      //   });
      // }
      setTimeout(() => {
        this.sensors.track(
          "YS_Content_Page",
          {
            refer_page: `${this.$route.query.acname}`,
            work_id: this.detailsNovel.id,
            total_chapter_num: this.ChapterNovel1.numbers_sum,
            author_id: this.detailsNovel.anchor_id,
            // played_id_list:`${this.currentNewsId}`,
            // played_times : `${parseInt(this.duration)}`
          },
          () => {
            console.log("success");
          }
        );
        // this.this.Timeduration
      }, 2000);
    },
    formatBit(val) {
      val = +val;
      return val > 9 ? val : "0" + val;
    }, // 秒转时分秒，求模很重要，数字的下舍入
    formatSeconds(time) {
      let min = Math.floor(time % 3600);
      let val =
        this.formatBit(Math.floor(time / 3600)) +
        ":" +
        this.formatBit(Math.floor(min / 60)) +
        ":" +
        this.formatBit(time % 60);
      return val;
    },
    //记录时长开始
    playTimeSC() {
      if (this.$refs.audio.currentTime !== undefined) {
        if (this.verNum >= 229) {
          this.playHistoryFunc(0);
        }
        let _THIS = this;
        window.timeName = setInterval(function () {
          _THIS.scTime = parseInt(_THIS.$refs.audio.currentTime);
          let obj = {
            rid: _THIS.musicUrl,
            duration: _THIS.scTime,
          };
          // this.fetchPlaytime(obj);
          if (_THIS.verNum >= 229) {
            _THIS.playHistoryFunc(_THIS.scTime);
          }
          _THIS.sensors.track(
            "YS_duratioin",
            {
              work_id: _THIS.detailsNovel.id,
              // total_chapter_num:this.ChapterNovel1.numbers_sum,
              author_id: _THIS.detailsNovel.anchor_id,
              played_id_list: `${_THIS.currentNewsId}`,
              played_long_list: `${parseInt(_THIS.duration)}`,
              played_duration_list: `${_THIS.scTime}`,
            },
            () => {
              console.log("success");
            }
          );
          // console.log(this.Timeduration)
        }, 10000);
      }
    },
    //复制
    onshare() {
      this.$copyText(this.text + ' ' + this.url).then(() => {
        this.$toast({
          message: '已成功复制到剪贴板！',
          forbidClick: true,
          duration: 1000,
        });
      });
    },
    playHistoryFunc(current_time = 0) {
      /**
       * 添加到历史记录
       * 需的参数为：
       * mobile（手机号
       * user_source（用户渠道来* 源
       * nid(小说ID)
       * chapter_id （章节ID）
       */
      if (!this.UserData) {
        return;
      }
      let sendData = {
        mobile: this.UserData.user_mobile,
        user_source: this.UserData.user_source,
        nid: this.novelSection,
        chapter_id: this.musicId,
        current_time,
      };
      if (current_time === 0) {
        this.fetchAddCollectAudio(sendData);
      } else {
        this.fetchUpdateCollectAudio(sendData);
      }
    },
    /**
     * 下载
     * nid 小说id
     */
    downLoadEvt(nid, e) {
      // 普通用户给予提示付费
      if (this.UserData.payment_status == 1) {
        this.$dialog
          .confirm({
            message: "VIP会员可以免费下载哦~",
          })
          .then(() => {
            if (window && window.android) {
              window.android.pay();
            }
            if (window && window.webkit && window.webkit.messageHandlers) {
              window.webkit.messageHandlers.pay.postMessage({});
            }
          })
          .catch(() => {});
      } else {
        if (window.android && window.android.getDownBoyinChapter) {
          window.android.getDownBoyinChapter(Number(nid));
        }

        if (window.webkit && window.webkit.messageHandlers) {
          window.webkit.messageHandlers.getDownBoyinChapter.postMessage(
            Number(nid)
          );
        }
      }
    },
  },
};
</script>
